import { ReactNode } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Text14 } from '@sorare/core/src/atoms/typography';
import {
  Bronze,
  Gold,
  Silver,
} from '@sorare/core/src/components/club/Trophies';

const Root = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: var(--intermediate-unit) 0;
`;
const Podium = styled(Vertical).attrs({ gap: 0.5, center: true })`
  justify-content: flex-start;
`;
const Count = styled(Text14)`
  background: var(--c-nd-100);
  border-radius: 50px;
  padding: 0 var(--unit);
`;

const podiums = ['top1', 'top2', 'top3'] as const;
type Podium = (typeof podiums)[number];

export type Props = {
  trophies: {
    top1: number;
    top2: number;
    top3: number;
  };
};

const podiumMessages = defineMessages<Podium>({
  top1: {
    id: 'ManagerProfile.Pro.Trophies.top1',
    defaultMessage: 'Gold',
  },
  top2: {
    id: 'ManagerProfile.Pro.Trophies.top2',
    defaultMessage: 'Silver',
  },
  top3: {
    id: 'ManagerProfile.Pro.Trophies.top3',
    defaultMessage: 'Bronze',
  },
});

const podiumTrophy: Record<Podium, ReactNode> = {
  top1: <Gold />,
  top2: <Silver />,
  top3: <Bronze />,
};

export const Trophies = ({ trophies }: Props) => {
  return (
    <Root>
      {podiums.map(podium => (
        <Podium key={podium}>
          {podiumTrophy[podium]}
          <Text14 color="var(--c-nd-600)">
            <FormattedMessage {...podiumMessages[podium]} />
          </Text14>
          <Count>x{trophies[podium]}</Count>
        </Podium>
      ))}
    </Root>
  );
};
